import ArrowDownIcon from '@/assets/icons/arrow-down.svg?react'
import { Trans } from '@/components'

interface AnnouncementBannerProps {
  show?: boolean
}

export const AnnouncementBanner = ({ show = true }: AnnouncementBannerProps) => {
  if (!show) return null
  return (
    <div
      className="
        group
        flex flex-col justify-center
        rounded-[18px]
        text-center bg-gradient-to-r from-[#00BAE2] to-[#2854F1]
        px-5 py-1 w-[520px]
        h-[50px] hover:h-[200px] hover:space-y-2
        overflow-hidden
        transition-all duration-300
      "
    >
      <div className="flex items-center justify-center space-x-2">
        <div>📢</div>
        <div className="t-sb text-white text-left text-ellipsis overflow-hidden whitespace-nowrap group-hover:whitespace-normal group-hover:overflow-visible group-hover:text-clip">
          <Trans i18nKey="header.announcementTitle">
            Region TW-01 is offline. Your data has been backed up in region TW-03.
          </Trans>
        </div>
        <div className="text-white/65">
          <ArrowDownIcon className="w-4 h-4 transition-transform duration-300 group-hover:rotate-180" />
        </div>
      </div>

      <div className="h-0 group-hover:h-[1px] bg-white bg-opacity-15" />

      <div
        className="
          text-left t-sb text-white
          h-0 group-hover:h-auto
          opacity-0 group-hover:opacity-100
          transition-opacity duration-300
        "
      >
        <Trans i18nKey="header.announcementContent">
          Please note that region TW-01 is taken offline at 12:00 on June 20, 2025. We have already
          backed up the DataDrive and Snapshot data from your account in region TW-01. Remount the
          data on Storage Capacity by reallocating the previously assigned DataDrive space from
          region TW-01 to region TW-03.
        </Trans>
      </div>
    </div>
  )
}
